"use strict";
//import { api_prefix } from "./index";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet_API_PATH = exports.WalletPath = void 0;
const wallet = "/wallet";
exports.WalletPath = {
    wallet,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${exports.WalletPath.wallet}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Wallet_API_PATH = {
    walletByClient: handlePath({
        path: `client`,
    }),
    create: handlePath({
        path: `create`,
    }),
    details: handlePath({
        path: `details`,
    }),
    addFund: handlePath({
        path: `add_fund`,
    }),
    verifyPayment: handlePath({
        path: `verify_payment`,
    }),
    transactions: handlePath({
        path: `transactions`,
    }),
    transaction: (id) => handlePath({
        path: `transactions/${id}`,
    }),
};
//# sourceMappingURL=wallet.js.map